import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";
import {CurrencyService, WindowRefService} from '@app/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss']
})

export class CurrencyComponent implements OnInit {

    currencys: {};
    currencyPlusUtil = [];
    defaultCurrency = { EUR:'EUR', USD:'USD', GBP:'GBP', MAD:'MAD', AED:'AED', AUD:'AUD', CAD:'CAD' };
    conteur : number = 0;
    selectedCurrency: string;

    constructor(private currencyService: CurrencyService, public translate: TranslateService, private winRef: WindowRefService, @Inject(MAT_DIALOG_DATA) data) {
        this.currencys = data.currency;
        this.selectedCurrency = this.winRef.appConfigSite.Ccurrency;
        data.currency.forEach(element => {
            if(element.cCode in this.defaultCurrency || element.cCode == this.selectedCurrency) {
                this.currencyPlusUtil[this.conteur] = element;
                this.conteur = this.conteur + 1;
            }
        });
    }

    changeCurrecny(value) {
        let promise = this.currencyService.changeCurrecny(value);
        promise.then( (rep)  => {
            let start = moment(this.winRef.appConfigSite.start).locale('en').format('YYYY-MM-DD'),
            end = moment(this.winRef.appConfigSite.end).locale('en').format('YYYY-MM-DD'),
            adults = this.winRef.appConfigSite.adults,
            enfants = this.winRef.appConfigSite.enfants,
            agesEnfants = this.winRef.appConfigSite.agesEnfants;
            this.winRef.generateNewUrlAndChanged(start, end, adults, enfants, agesEnfants);
        })
    }

    ngOnInit() {
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

}
